<template>
	<div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">
		<div v-if="!stuForm.id" style="padding: 15px;">
			<van-cell-group>

				<div style="text-align: center; background-color: #fff; padding: 20px;">{{ school_name }}</div>
				<div style="height: 50px;"></div>
				<!-- 	<van-field v-model="stuForm.stu_name" label="学生姓名" placeholder="请输入姓名" /> -->
				<van-field v-model="stuForm.identity_card" label="身份证号" placeholder="请输入考生身份证号" />
				<div style="height: 50px;"></div>
				<div class="submitBtn flexAround">
					<div class="btn" @click="onSearch" style="width: 40%;">查询</div>
				</div>
				<div style="height: 50px;"></div>
			</van-cell-group>
		</div>


		<div v-else>

			<van-cell-group>

				<div style="padding: 20px; font-size: 14px; position: relative;">
					<div style="font-weight: bold;">
						报名信息
					</div>
					<div style="padding-top: 10px; color: #888;">
						报名时间：{{ stuForm.cdate }}
					</div>

					<div style="position: absolute; top: 10px; right: 30px; width: 60px;">
						<img v-if="stuForm.status == 0" src="//aiwx.org.cn/static/icon/static/sp_normal.png"
							style="width: 100%;">
						<img v-if="stuForm.status == 1" src="//aiwx.org.cn/static/icon/static/sp_over.png"
							style="width: 100%;">
						<img v-if="stuForm.status == -1" src="//aiwx.org.cn/static/icon/static/sp_fail.png"
							style="width: 100%;">

					</div>
					<div style="font-size: 12px; color: orangered;" v-if="stuForm.status == -1">
						{{ stuForm.sp_word }}
					</div>

					<div v-if="stuForm.status == -1 && stuForm.openid == nowOpenid"
						style="text-align:right;padding-top:10px">
						<el-button @click="goResult" type="danger" size="small" icon="el-icon-collection"
							style="margin-top: 0px;">重新修改报名信息<i class="el-icon-right"></i></el-button>

					</div>
					<div v-if="stuForm.status == -1 && stuForm.openid != nowOpenid"
						style="text-align:right;padding-top:10px">
						请使用报名时的微信登录后再修改信息
					</div>

				</div>

				<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
					<span class="rowlabel"></span>考生信息 <div @click="resetForm" style="float: right; color: dodgerblue;">
						←返回查询
					</div>
				</div>

				<van-field readonly v-model="stuForm.stu_name" label="考生姓名" label-width="110px" />
				<!-- <van-field readonly v-model="stuForm.exam_num" v-if="stuForm.exam_num" label="准考证号"
					label-width="110px" /> -->
				<van-field readonly v-model="stuForm.phone" label="手机号" label-width="110px" />
				<van-field readonly :value="stuForm.identity_card" label="身份证号" label-width="110px" />
				<van-field readonly v-model="stuForm.birthday" label="出生年月" label-width="110px" />
				<van-field readonly :value="stuForm.gender == 1 ? '男' : '女'" label="性别" label-width="110px" />
				<van-field readonly v-model="stuForm.minzu" label="民族" label-width="110px" />
				<van-field readonly v-model="stuForm.hkxz" label="户口性质" label-width="110px" />
				<van-field readonly v-model="stuForm.hkszd" label="户口所在" label-width="110px" />
				<van-field readonly v-model="stuForm.graduate_sch_city" label="所在地区" label-width="110px" />
				<van-field readonly v-model="stuForm.graduate_schname" label="所在学校" label-width="110px" />
				<van-field readonly v-model="stuForm.ly_type" label="考生来源" label-width="110px">
					<template #input>
						<span v-if="stuForm.ly_type == 1">应届生（本年度6月份毕业）</span>
						<span v-if="stuForm.ly_type == 2">往届生（上一年度毕业生）</span>
						<span v-if="stuForm.ly_type == 3">在校生（初一年级）</span>
						<span v-if="stuForm.ly_type == 4">在校生（小学五年级）</span>

					</template>
				</van-field>
				<van-field readonly v-model="stuForm.jtzz" label="收件地址" label-width="110px" />
				<van-field readonly v-model="stuForm.jhr1name" label="收件人" label-width="110px" />
				<van-field readonly v-model="stuForm.major.title" label="报考专业名称" label-width="110px" />
				<van-field readonly v-model="stuForm.major.item_desc" label="学制" label-width="110px" />
				<van-field readonly v-model="stuForm.graduate_schname" label="户口簿/身份证" label-width="110px">
					<template #input>
						<div style="width: 50%; margin: 0 auto;">
							<img :src="stuForm.otherjson.identity_card1" style="width: 100%;" />
						</div>

					</template>
				</van-field>
				<van-field readonly v-model="stuForm.graduate_schname" label="证件照" label-width="110px">
					<template #input>
						<div style="width: 50%; margin: 0 auto;">
							<img :src="stuForm.otherjson.dzzj" style="width: 100%;" />
						</div>

					</template>
				</van-field>
				<van-field readonly v-model="stuForm.graduate_schname" label="学籍证明" label-width="110px">
					<template #input>
						<div style="width: 50%; margin: 0 auto;">
							<img :src="stuForm.otherjson.score" style="width: 100%;" />
						</div>

					</template>
				</van-field>
				<div style="height: 50px;">

				</div>
			</van-cell-group>


		</div>


	</div>




</template>

<script>
import {
	Dialog,
	Toast,
	Uploader
} from 'vant';
export default {
	components: {

	},
	data() {
		return {
			school_name: "江苏省戏剧学校",
			stuForm: {
				id: 0,
				identity_card: ""
			},
			pmid: 6,
			nowOpenid: ""
		}
	},
	mounted() {
		this.pmid = this.$route.query.pmid || 6

		document.title = "考生信息查询"
		this.nowOpenid = this.$route.query.openid
		if(this.$route.query.card){
			this.stuForm.identity_card = this.$route.query.card
			this.getStudents()
		}
	},
	methods: {
		onSearch() {
			//alert("未到开放查询时间")
			if (!this.stuForm.identity_card) {
				Toast('请输入正确的身份证号');
			} else {
				var myreg =
					/(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/
				if (!myreg.test(this.stuForm.identity_card)) {
					Toast('请输入正确的身份证号');
					return
				} else {
					this.getStudents()
				}



			}
		},
		resetForm() {
			this.stuForm = {
				id: 0,
				identity_card: ""
			}
		},
		getStudents() {

			this.$http.post("/api/app_stuinfo", {
				pmid: this.pmid,
				identity_card: this.stuForm.identity_card
			}).then(res => {

				if (res.data) {
					res.data.otherjson = JSON.parse(res.data.otherjson)
					this.stuForm = res.data

				} else {
					Dialog.alert({
						title: '提示',
						message: '未找到报名信息！',
						theme: 'round-button',
					}).then(() => {
						// on close
					});
				}



			})
		},
		goResult() {
			console.log("跳转链接")
			console.log("/bk?pmid=" + window.pmid + "&openid=" + this.$route.query.openid)
			this.$router.push("/bk?pmid=" + window.pmid + "&openid=" + this.$route.query.openid+"&edit="+this.stuForm.id)
		}
	},

}
</script>


<style lang="less" type="text/less">
.van-radio__icon {
	font-size: 16px;
}

.van-radio__icon--checked .van-icon {
	background-color: #00cfdc;
	border-color: #00cfdc;
}

.submitBtn {
	margin-top: 2vh;
	margin-bottom: 50px;

	.btn {
		display: inline-block;
		padding: 1.4vh 8%;
		background-color: #00CFDC;
		color: #fff;
		font-size: 15px;
		border-radius: 5vw;
		width: 50%;
		text-align: center;
	}

	.btn:active {

		background-color: #007AFF;

	}
}

.xm {
	border: 1px solid #ccc;
	display: inline-block;
	margin: 0 10px 10px 0;
	padding: 4px 10px;
	border-radius: 4px;
}

.xmckd {
	background-color: orangered;
	color: #fff;
}
</style>

</style>
